var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCalendar(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.87 5.604a1.935 1.935 0 00-1.364-.561h-.642v-.401c0-.401-.24-.642-.562-.642-.32 0-.641.24-.641.642v.4H8.81v-.4A.633.633 0 008.169 4c-.32 0-.561.24-.561.642v.4h-.562c-.481 0-1.042.161-1.444.562-.32.401-.561.882-.561 1.444v7.54c0 .48.16.962.561 1.363.321.32.803.561 1.364.561h7.62c.481 0 .962-.24 1.363-.561.321-.32.562-.802.562-1.364v-7.7c-.08-.48-.24-.962-.642-1.283zm-.643 8.983c0 .16-.08.321-.16.482-.16.16-.32.16-.481.16h-7.7c-.16 0-.321-.08-.481-.16-.16-.16-.16-.321-.16-.482V8.492h8.02c.32 0 .642-.241.642-.642s-.241-.642-.642-.642h-8.02v-.16c0-.24.08-.401.24-.562.16-.16.4-.24.561-.24H14.506c.16 0 .32.08.48.16.161.16.161.321.161.482v7.7h.08z",
    fill: "#333"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.854 9.775H8.089c-.24 0-.401.16-.401.401v.882c0 .241.16.401.4.401h1.766c.24 0 .4-.16.4-.4v-.883c0-.24-.16-.401-.4-.401z",
    fill: "#333"
  })));
}
export default SvgCalendar;